<template>
  <!-- 
    时间：2019-10-26
    描述：设置-第三方参数设置
   -->
  <div class="index">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <div class="common-form">
        租先知配置参数
      </div>
      <div>
        <el-form-item label="zuapp_id">
          <el-input v-model="form.zuapp_id" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="zusecret">
          <el-input v-model="form.zusecret" class="max-w460"></el-input>
        </el-form-item>
      </div>
      <div class="common-form">
        宝付代扣商户
      </div>
      <div>
        <el-form-item label="商户号">
          <el-input v-model="form.merchant_id" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="终端号">
          <el-input v-model="form.terminal_id" class="max-w460"></el-input>
        </el-form-item>
      </div>
      <div class="common-form">
        百融账户信息
      </div>
      <el-form-item label="账号">
        <el-input v-model="form.br_account" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="密码">
        <el-input v-model="form.br_password" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="appkey">
        <el-input v-model="form.br_appkey" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="apiCode">
        <el-input v-model="form.br_apiCode" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="strategy_id">
        <el-input v-model="form.br_strategy_id" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="conf_id">
        <el-input v-model="form.br_conf_id" class="max-w460"></el-input>
      </el-form-item>
      <div class="common-form">
        掌签的参数KEY
      </div>
      <el-form-item label="ID">
        <el-input v-model="form.zq_id" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="SECRET">
        <el-input v-model="form.zq_secret" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="KEY">
        <el-input v-model="form.zq_key" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="密钥ID">
        <el-input v-model="form.zq_accessKeyId" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="商户名称">
        <el-input v-model="form.zq_businessName" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="BUCKET">
        <el-input v-model="form.zq_bucket" class="max-w460"></el-input>
      </el-form-item>
      <div class="common-form">
        布尔的参数
      </div>
      <el-form-item label="ID">
        <el-input v-model="form.bool_id" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="KEY">
        <el-input v-model="form.bool_key" class="max-w460"></el-input>
      </el-form-item>
      <div class="common-form">
        分账
      </div>
      <el-form-item label="开通分账">
        <el-radio-group v-model="form.div_acc">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="支付方式">
        <el-radio-group v-model="form.pay_mtd">
          <el-radio :label="1">连连</el-radio>
          <el-radio :label="2">宝付</el-radio>
          <el-radio :label="3">支付宝官方</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="d-s-c">
        <div class="common-form">
          赋强公证
        </div>
        <div class="" style="margin-left: 70px;">
          <el-radio v-model="radio_client" label="gz" border size="medium">广州南沙
          </el-radio>
          <el-radio v-model="radio_client" label="sh" border size="medium">上海
          </el-radio>
          <el-radio v-model="radio_client" label="cd" border size="medium">成都易证
          </el-radio>
          <el-radio v-model="radio_client" label="lj" border size="medium">鹭江
          </el-radio>
        </div>
      </div>
      <el-form-item label="template_id">
        <el-input v-model="form.fq_template_id" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="client_id">
        <el-input v-model="form.fq_client_id" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="client_secret">
        <el-input v-model="form.fq_client_secret" class="max-w460"></el-input>
      </el-form-item>

      <div class="d-s-c">
        <div class="common-radio">
          电子合同
        </div>
        <div class="" style="margin-left: 70px;">
          <el-radio v-model="radio" label="aiQ" border size="medium">爱签
          </el-radio>
          <el-radio v-model="radio" label="eQ" border size="medium">E签宝
          </el-radio>
        </div>
      </div>
      <!-- 爱签 -->
      <template v-if="radio === 'aiQ'">
        <div class="common-form">
          爱签
        </div>
        <el-form-item label="app_id">
          <el-input v-model="form.aq_app_id" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="密钥">
          <el-input v-model="form.aq_api_secret" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="环境地质">
          <el-input v-model="form.aq_domian" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="公钥">
          <el-input v-model="form.aq_public_key" class="max-w460"></el-input>
        </el-form-item>
      </template>
      <!-- e签宝 -->
      <template v-if="radio === 'eQ'">
        <div class="common-form">
          e签宝
        </div>
        <el-form-item label="APPID">
          <el-input v-model="form.APPID" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="密钥">
          <el-input v-model="form.AppSecret" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="商户名称">
          <el-input v-model="form.orgName" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.shop_phone" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="商家id">
          <el-input v-model="form.OrgId" style="max-width: 372px;"></el-input>
          <el-button type="warning" @click="createOrgId">生成OrgId</el-button>
        </el-form-item>
        <el-form-item label="模板id">
          <el-input v-model="form.docTemplateId" class="max-w460"></el-input>
        </el-form-item>
      </template>

      <div class="" style="height: 100px;"></div>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="editForm" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import SettingApi from "@/api/setting.js";
export default {
  props: {},
  data() {
    return {
      loading: false,
      radio: "aiQ",
      radio_client: "gz", // 'gz' | 'sh' | 'cd'
      form: {
        // 租先知
        zuapp_id: "",
        zusecret: "",

        // 商户号、终端号
        merchant_id: "",
        terminal_id: "",

        // 掌签的参数KEY id secret key
        zq_id: "",
        zq_secret: "",
        zq_key: "",
        zq_accessKeyId: "",
        zq_businessName: "",
        zq_bucket: "",

        // 百融账户信息 账号 密码 appkey apiCode strategy_id conf_id
        br_account: "",
        br_password: "",
        br_appkey: "",
        br_apiCode: "",
        br_strategy_id: "",
        br_conf_id: "",

        // 布尔的参数 id key
        bool_id: "",
        bool_key: "",

        div_acc: "",
        pay_mtd: "",

        // 赋强公证 template_id client_id client_secret
        fq_template_id: "",
        fq_client_id: "",
        fq_client_secret: "",

        // 爱签
        aq_app_id: "",
        aq_api_secret: "",
        aq_domian: "",
        aq_public_key: "",

        // E签宝
        APPID: "",
        AppSecret: "",
        OrgId: "",
        shop_phone: "",
        docTemplateId: "",
        orgName: ""
      }
    };
  },
  methods: {
    getData() {
      const self = this;
      SettingApi.thirdPartyDetail({}, true)
        .then(({ data: { vars } }) => {
          self.form = Object.keys(vars.values).reduce((pre, key) => {
            if (key !== "elecContract") {
              pre[key] = vars.values[key];
            }
            return pre;
          }, {});
          vars.values.elecContract &&
            (self.radio = vars.values.elecContract);
        })
        .catch(err => self.$message.warning("无法获取接口信息"));
    },
    editForm() {
      const self = this;
      const params = { ...this.form };
      params["elecContract"] = self.radio;
      SettingApi.thirdPartyEdit(params, true)
        .then(res => {
          self.$message.success("修改成功");
        })
        .catch(err => console.log(err));
    },
    async createOrgId() {
      await SettingApi.createOrgId({}, true);
      this.getData();
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
/*choose*/
.common-radio {
  position: relative;
  padding-left: 10px;
  font-size: 16px;
  font-weight: 700;
}

.common-radio:before {
  position: absolute;
  content: "";
  width: 4px;
  height: 14px;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.common-radio:before {
  background: #999999;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/otherparams/index.vue